import 'prop-types';
import { enUSTranslations } from '../locale/translations.js';

var useTranslations = function useTranslations(externalTranslations) {
  var replaceVariables = function replaceVariables(keyString, values) {
    return keyString.replace(/{{(.*?)}}/g, function (_match, offset) {
      return values[offset];
    });
  };

  var t = function t(key, values) {
    var externalTranslation = externalTranslations && externalTranslations[key];
    var translation = externalTranslation || enUSTranslations[key];
    if (!translation) return key;
    if (!values) return translation;
    return replaceVariables(translation, values);
  };

  return {
    t: t
  };
};

export { useTranslations };
